import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Modal } from "react-bootstrap";
import {
  logisticsLinkToBarcodeParams,
  logisticsUnlinkToBarcodeParams,
} from "../../../../../Backend/LogisticsRequests";
import { hasValue } from "../../../../../Helpers/validations/common";
import { SCHOOL_RETURNS_BY_SCHOOL } from "../../../../../Constants/Endpoints";
import TableTemplate from "../../../../../Components/Table/TableTemplate";
import SchoolSelection from "../../../../../Components/SchoolSelection/SchoolSelection";
import "./LinkToBarcodeModal.scss";

export function LinkToBarcodeModal({ logisticsPackage, submit, ...props }) {
  const tableBarcodesRef = useRef(null);
  const [t] = useTranslation();
  const [highlightKey] = useState("id");
  const [schoolSelected, setSchoolSelected] = useState();
  const [schoolSelection, setSchoolSelection] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear());

  const [studentSelected, setStudentSelected] = useState();
  const [studentSelection, setStudentSelection] = useState(false);
  const [highlightStudentValues, setHighlightStudentValues] = useState([]);

  const logisticsLinkToBarcode = async () => {
    const resp = await logisticsLinkToBarcodeParams(
      logisticsPackage.id,
      highlightStudentValues[0]
    );

    if (resp.success) {
      submit();
    }
  };

  const logisticsUnlinkToBarcode = async () => {
    const resp = await logisticsUnlinkToBarcodeParams(logisticsPackage.id);

    if (resp.success) {
      submit();
    }
  };

  const barcodeColumns = [
    {
      name: "barcode",
      headerCaption: t("Barcode"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "student.firstName",
      filterName: "user.firstName",
      sortName: "user.firstName",
      headerCaption: t("Name"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "student.preposition",
      filterName: "user.preposition",
      sortName: "user.preposition",
      headerCaption: t("Preposition"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "student.lastName",
      filterName: "user.lastName",
      sortName: "user.lastName",
      headerCaption: t("LastName"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "actions",
      headerCaption: "",
      size: "small",
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) => {
        return (
          <Button
            className="button-selected"
            disabled={highlightStudentValues[0] === x.id}
            onClick={() => {
              setStudentSelected(x);
              setHighlightStudentValues([x.id]);
              setStudentSelection(false);
            }}
          >
            {highlightStudentValues[0] === x.id ? t("Selected") : t("Select")}
          </Button>
        );
      },
    },
  ];

  return (
    <Modal {...props} centered dialogClassName="link-to-barcode-modal">
      <Modal.Header className="link-to-barcode-modal-header" closeButton>
        <h2 className="title">{t("PackageInfo")} </h2>
      </Modal.Header>
      <Modal.Body className="link-to-barcode-modal-content">
        <SchoolSelection
          schoolSelected={schoolSelected}
          schoolSelection={schoolSelection}
          onClickChange={() => {
            if (schoolSelection) {
              setSchoolSelection(false);
            } else {
              setSchoolSelection(true);
            }
          }}
          setSchoolSelection={setSchoolSelection}
          setSchoolSelected={setSchoolSelected}
        />

        <div className="selection-wrapper">
          <div className="banner-wrapper">
            <div className="banner-wrapper-title-wrapper">
              <div className="banner-wrapper-title">{t("Student")}</div>
              <div className="banner-wrapper-subtitle">
                {studentSelected
                  ? `${studentSelected.student.firstName} ${studentSelected.student.preposition} ${studentSelected.student.lastName}`
                  : t("NotSelected")}
              </div>
            </div>
            <Button
              className="button-banner"
              disabled={!hasValue(schoolSelected?.id)}
              onClick={() => {
                if (studentSelection) {
                  setStudentSelection(false);
                } else {
                  setStudentSelection(true);
                }
              }}
            >
              {highlightStudentValues.length === 0 ? t("Select") : t("Change")}
            </Button>
          </div>
          <div
            className={`table-selection-wrapper${
              studentSelection ? ` show` : ``
            }`}
          >
            {studentSelection && (
              <TableTemplate
                ref={tableBarcodesRef}
                title={t("Students")}
                pageSize={5}
                highlightValues={highlightStudentValues}
                highlightKey={highlightKey}
                endpoint={
                  SCHOOL_RETURNS_BY_SCHOOL + "?schoolId=" + schoolSelected?.id
                }
                extraFilters={[
                  {
                    name: "year",
                    headerCaption: t("Year"),
                    value: year,
                    component: (
                      <Form.Control
                        value={year}
                        onChange={(x) => setYear(x.target.value)}
                      />
                    ),
                  },
                ]}
                columns={barcodeColumns}
                uniqueId="id"
                paginator={true}
                showSizeSelector={false}
              />
            )}
          </div>
        </div>

        <div className="button-wrapper">
          {console.log(logisticsPackage)}
          {logisticsPackage.barcode && (
            <Button
              className="button-unlink"
              onClick={() => logisticsUnlinkToBarcode()}
            >
              {t("Unlink")}
            </Button>
          )}
          <Button
            className="button"
            disabled={highlightStudentValues.length === 0}
            onClick={() => logisticsLinkToBarcode()}
          >
            {t("Confirm")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
